export default {
  addOns: 'Suplimente',
  all: 'Toate',
  browse: 'Răsfoiește',
  buyTickets: 'Cumpără bilete',
  countSelected: '{{count}} selectate',
  joinWaitlist: 'Înscrie-te pe lista de așteptare',
  joining: 'Se înscrie',
  salesEnded: 'Vânzările s-au încheiat',
  schedule: 'Program',
  soldOut: 'Epuizat',
  tickets: 'Bilete',
  noDatesAvailable: 'Nu sunt date disponibile',
  seeMoreDates: 'Vezi mai multe date',
  about: 'Despre',
  agenda: 'Agendă',
  menu: 'Meniu',
  included: 'Inclus',
  viewMore: 'Vezi mai mult',
  viewLess: 'Vezi mai puțin',
  location: 'Locație',
  time: 'Ora',
  at: 'la',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Nu sunt ore disponibile în această dată pentru această dimensiune a grupului',
  availableTimes: 'Ore disponibile',
  waitlist: 'Lista de așteptare',
  continue: 'Continuă',
  ticketsAreNoLongerAvailable: 'Biletele nu mai sunt disponibile.',
  checkOutOutOtherExperiences: 'Verifică celelalte experiențe ale noastre!',
  viewExperiences: 'Vezi experiențele',
  from: 'de la',
  cancellationPolicy: 'Politica de anulare',
  rsvp: 'RSVP',
  nights: 'nopți',
  request: 'Solicitare',
  arrival: 'Sosire',
  departure: 'Plecare',
};
